"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDrillDownDefinition = exports.isEmptyAfm = exports.isInvalidBuckets = exports.isPluggableVisualizationError = exports.EmptyAfmSdkError = exports.InvalidBucketsSdkError = exports.PluggableVisualizationErrorCodes = exports.ConfigPanelClassName = exports.DATE_DATASET_ATTRIBUTE = void 0;
var tslib_1 = require("tslib");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var sdk_ui_1 = require("@gooddata/sdk-ui");
exports.DATE_DATASET_ATTRIBUTE = "attr.datedataset";
/**
 * Class name of element where pluggable visualization is supposed to render its configuration
 * panels.
 *
 * @alpha
 */
exports.ConfigPanelClassName = "gd-configuration-panel-content";
/**
 * @alpha
 */
exports.PluggableVisualizationErrorCodes = {
    /**
     * If pluggable visualization is asked to render itself but its buckets do not contain the right 'stuff',
     * then this is the error code to communicate the fact.
     */
    INVALID_BUCKETS: "INVALID_BUCKETS",
    /**
     * This error means that empty AFM was went to the GoodData.UI and as such can't be executed.
     */
    EMPTY_AFM: "EMPTY_AFM",
};
/**
 * @alpha
 */
var InvalidBucketsSdkError = /** @class */ (function (_super) {
    tslib_1.__extends(InvalidBucketsSdkError, _super);
    function InvalidBucketsSdkError(cause) {
        var _this = _super.call(this, sdk_ui_1.ErrorCodes.UNKNOWN_ERROR, undefined, cause) || this;
        _this.pveType = "INVALID_BUCKETS";
        return _this;
    }
    InvalidBucketsSdkError.prototype.getErrorCode = function () {
        return this.pveType;
    };
    return InvalidBucketsSdkError;
}(sdk_ui_1.GoodDataSdkError));
exports.InvalidBucketsSdkError = InvalidBucketsSdkError;
/**
 * @alpha
 */
var EmptyAfmSdkError = /** @class */ (function (_super) {
    tslib_1.__extends(EmptyAfmSdkError, _super);
    function EmptyAfmSdkError(cause) {
        var _this = _super.call(this, sdk_ui_1.ErrorCodes.UNKNOWN_ERROR, undefined, cause) || this;
        _this.pveType = "EMPTY_AFM";
        return _this;
    }
    EmptyAfmSdkError.prototype.getErrorCode = function () {
        return this.pveType;
    };
    return EmptyAfmSdkError;
}(sdk_ui_1.GoodDataSdkError));
exports.EmptyAfmSdkError = EmptyAfmSdkError;
/**
 * @alpha
 */
function isPluggableVisualizationError(obj) {
    return !isEmpty_1.default(obj) && obj.pveType !== undefined;
}
exports.isPluggableVisualizationError = isPluggableVisualizationError;
/**
 * @alpha
 */
function isInvalidBuckets(obj) {
    return !isEmpty_1.default(obj) && obj.pveType === "INVALID_BUCKETS";
}
exports.isInvalidBuckets = isInvalidBuckets;
/**
 * @alpha
 */
function isEmptyAfm(obj) {
    return !isEmpty_1.default(obj) && obj.pveType === "EMPTY_AFM";
}
exports.isEmptyAfm = isEmptyAfm;
/**
 * Type-guard testing whether the provided object is an instance of {@link IDrillDownDefinition}.
 * @beta
 */
function isDrillDownDefinition(obj) {
    return !isEmpty_1.default(obj) && obj.type === "drillDown";
}
exports.isDrillDownDefinition = isDrillDownDefinition;
//# sourceMappingURL=Visualization.js.map